// Chemin: C:\gestion-copro\src\services\export.service.ts
// Session 185 : Service export données utilisateur (RGPD portabilité)
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

// ============================================================
// TYPES
// ============================================================

interface ExportStats {
  documents: number;
  courriersEntrants: number;
  courriersSortants: number;
  signalements: number;
  dossiers: number;
  contacts: number;
  echeances: number;
  conversations: number;
  fichiers: number;
}

interface ExportResult {
  downloadUrl: string;
  expiresAt: string;
  fileSize: number;
  stats: ExportStats;
}

// ============================================================
// SERVICE EXPORT
// ============================================================

/**
 * Lance l'export complet des données utilisateur.
 * Retourne l'URL de téléchargement du ZIP.
 */
export async function lancerExportDonnees(): Promise<ExportResult> {
  const exportFn = httpsCallable<void, ExportResult>(functions, "exportUserData");
  const result = await exportFn();
  return result.data;
}

/**
 * Déclenche le téléchargement du ZIP dans le navigateur.
 * Utilise un lien <a> sans target="_blank" pour éviter le bloqueur de pop-ups.
 */
export function telechargerExport(downloadUrl: string, dateStr?: string): void {
  const date = dateStr || new Date().toISOString().split("T")[0];
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = `export-copro-protect-${date}.zip`;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Formate la taille du fichier pour affichage.
 */
export function formaterTailleFichier(octets: number): string {
  if (octets < 1024) return `${octets} o`;
  if (octets < 1024 * 1024) return `${(octets / 1024).toFixed(1)} Ko`;
  return `${(octets / (1024 * 1024)).toFixed(1)} Mo`;
}
